import { render, staticRenderFns } from "./researchCropList.vue?vue&type=template&id=7509ab32&scoped=true&"
import script from "./researchCropList.vue?vue&type=script&lang=js&"
export * from "./researchCropList.vue?vue&type=script&lang=js&"
import style0 from "./researchCropList.vue?vue&type=style&index=0&id=7509ab32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7509ab32",
  null
  
)

export default component.exports